import axios from "../axios-auth";
import orginal_axios from "axios";


export const manufacturingAccountService = {
    getManufacturingAccountList,
    saveManufacturingAccount,
    getManufacturingAccountById,
    getManufacturingAccountForPreview,
    exportManufacturingAccountPreview,
    exportManufacturingAccount
};

function getManufacturingAccountForPreview(manufacturingAccount) {
    // preview
    return axios.post("/auth/preview-manufacturing-account", manufacturingAccount);
}

function getManufacturingAccountList(searchParams, page, size, sortedBy) {
    if (!page) {
        page = 0;
    } else {
        page -= 1;
    }
    if (!size) {
        size = 50;
    }

    let params = {
        page: page,
        size: size,
        sort: sortedBy
    };

    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }
    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }
    if (searchParams.code) {
        params["code"] = searchParams.code;
    }
    if (searchParams.shopIds) {
        params["shopIds"] = searchParams.shopIds.join();
    }
    return axios.get("/auth/manufacturing-accounts", { params });
}

function saveManufacturingAccount(manufacturingAccount) {
    if (!manufacturingAccount.id) {
        // new income statement
        return axios.post("/auth/manufacturing-account", manufacturingAccount);
    } else {
        return axios.put("/auth/manufacturing-account", manufacturingAccount);
    }
}

function getManufacturingAccountById(id) {
    return axios.get("/auth/manufacturing-account/" + id);
}

function exportManufacturingAccountPreview(searchParams, shopCode) {
    let params = {
    };
    if (searchParams.fromMonth) {
        params["fromMonth"] = searchParams.fromMonth;
    }
    if (searchParams.toMonth) {
        params["toMonth"] = searchParams.toMonth;
    }
    if (searchParams.shopIds) {
        params["shopIds"] = searchParams.shopIds;
    }
    if (shopCode) {
        params["shopCode"] = shopCode;
    }
    if (searchParams.balanceType) {
        params["balanceType"] = searchParams.balanceType;
    }
    if (searchParams.financeSettingId) {
        params["financeSettingId"] = searchParams.financeSettingId;
    }

    return orginal_axios({
        method: "GET",
        url: axios.defaults.baseURL + "/auth/preview-manufacturing-account-excel",
        params,
        responseType: "arraybuffer", // important
        headers: {
            Authorization: "Bearer " + localStorage.getItem("accessToken"),
            Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            "Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        }
    }).then(function (response) {
        return { blob: new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }), headers: response.headers }
    });
}

function exportManufacturingAccount(id) {
    return orginal_axios({
        method: "GET",
        url: axios.defaults.baseURL + "/auth/preview-manufacturing-account-detail-excel/" + id,
        responseType: "arraybuffer", // important
        headers: {
            Authorization: "Bearer " + localStorage.getItem("accessToken"),
            Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            "Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        }
    }).then(function (response) {
        return { blob: new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }), headers: response.headers }
    });
}
